import { submitDeleteFlows } from './delete/submitDeleteFlows'
import { submitNewFlows } from './new/submitNewFlows'
import { submitUpdateFlows } from './update/submitUpdateFlows'

export const submitFlows = [
  ...submitDeleteFlows,
  ...submitUpdateFlows,
  ...submitNewFlows,
]
